export default __webpack_public_path__ + "static/media/Fact6.2faa6664.png";